import {
  Button,
  Card,
  ModalComponentWrapper,
  ResultContent,
} from '@/shared/components';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/utils';
import type { WithdrawCommissionData } from '@/shared/types';
import { InfoDataTable } from '@/shared/components/InfoDataTable.tsx';

interface ResultModalProps {
  success: boolean;
  data: { commissionData: WithdrawCommissionData; address: string };
  onClose: () => void;
  onSaveAddress: () => void;
  isNeedToSaveTemplate?: boolean;
}

export function ResultModal({
  success,
  data,
  onClose,
  onSaveAddress,
  isNeedToSaveTemplate,
}: ResultModalProps) {
  const { t } = useTranslation();

  const title = success ? t('common.readyTitle') : t('common.errorTitle');
  const description = success
    ? t('withdrawMethods.crypto.result.successDescription')
    : t('withdrawMethods.crypto.result.tryAgain');
  const closeBtnText = success ? t('common.doneButton') : t('common.close');

  const tableData = [
    {
      key: t('withdrawMethods.crypto.result.totalWithdraw'),
      value: data.commissionData.totalWithdrawAmountStr,
    },
    {
      key: t('withdrawMethods.crypto.result.withdrawFee'),
      value: data.commissionData.feeStr,
    },
    {
      key: t('withdrawMethods.crypto.result.toAddress'),
      value: data.address,
    },
  ];

  return (
    <ModalComponentWrapper
      footer={
        <Button
          type="submit"
          variant="default"
          size="lg"
          onClick={onClose}
          className={cn('w-full')}>
          {closeBtnText}
        </Button>
      }>
      <ResultContent
        className="h-auto"
        isSuccess={success}
        showButton={false}
        title={title}
        description={description}>
        {success && (
          <Card variant="details" className="w-full">
            {success && <InfoDataTable data={tableData} className="p-0" />}

            {isNeedToSaveTemplate && (
              <Button
                variant="secondary"
                size="small"
                onClick={onSaveAddress}
                className="w-full mt-[0.8rem] bg-stroke-bg">
                {t('common.saveAddress')}
              </Button>
            )}
          </Card>
        )}
      </ResultContent>
    </ModalComponentWrapper>
  );
}
